import { Paper, Stack, Switch, Text, Title, useMantineColorScheme } from "@mantine/core";

export const AppearancePreferences = () => {
	const { colorScheme, toggleColorScheme } = useMantineColorScheme();

	return <>
		<Stack gap={0}>
			<Title order={2}>Appearance Preferences</Title>
		</Stack>

		<Paper withBorder p="lg" mt="md" radius="lg">
			<Title order={4}>Theme</Title>
			<Switch
				checked={colorScheme === "dark"}
				onChange={() => toggleColorScheme()}
				label="Use dark theme for dashboard"
				mt="md"
			/>
		</Paper>
	</>
}